import React from 'react';
const Notice = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='24' height='24' rx='12' fill='#FFDE31' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.4 5.004c.516 0 .934.418.934.933v7.467a.933.933 0 0 1-1.867 0V5.937c0-.515.418-.933.933-.933z'
        fill='#000'
      />
      <circle cx='12.399' cy='17.595' r='1.4' fill='#000' />
    </svg>
  );
};

export default Notice;
